import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function toWebp(src) {
  const webp = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');
  return webp.replace(/ /g, '%20');
}

function GalleryModal(prop) {
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={true}
      onHide={prop.onClose}
    >
      <div className='modal-background'>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <picture>
            <source srcSet={toWebp(prop.photo)} type="image/webp" />
            <img className='photo-modal' src={prop.photo} alt={prop.alt || "Tralo paslaugų galerijos nuotrauka"} width="1280" height="720" />
          </picture>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={prop.onClose}>
            {prop.strings.galleryModal.closeButton}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default GalleryModal;
